<template>
  <div>
    <base-header class="pb-8 pt-4" />
    <div class="container-fluid mt--7">
      <b-card no-body>
        <b-card-header>
          <div class="align-items-center row">
            <div class="col d-flex align-items-center">
              <h3 class="card-title mb-0">{{ $t("Ürün Siparişleri") }}</h3>
              <div class="text-sm ml-4" style="width:200px;">
                <b-form-group class="mb-0">
                  <b-form-select v-model="status" :options="statusOptions" @change="refreshTable" />
                </b-form-group>
              </div>
            </div>
          </div>
        </b-card-header>

        <b-table ref="table" class="align-items-center" thead-class="thead-light" :fields="fields" :items="getItems" responsive show-empty>

          <template v-slot:table-busy>
            <div style="width: 100%; text-align:center;">
              <b-spinner label="Spinning"></b-spinner>
            </div>
          </template>

          <template v-slot:empty>
            <b-alert variant="warning" show>{{ $t("Henüz bir şey eklenmemiş") }}!</b-alert>
          </template>

          <template v-slot:cell(price)="data">
            {{ data.item.product ? data.item.product.total * data.item.piece : 'Ürün Silinmiş' }}
          </template>

          <template v-slot:cell(status)="data">
            <b-form-select v-model="data.item.status" :options="statusOptions" @change="changeItemStatus(data.item)" />
          </template>

          <template v-slot:cell(company)="data">
            <a href="#" class="text-underline" @click="company = data.item.company;$refs.companyModal.show()">{{ data.item.company.title }}</a>
          </template>

        </b-table>

        <div class="w-100 d-flex align-items-center justify-content-center mt-2 mb-3" v-if="pagination.totalRows > 14">
          <b-pagination v-model="pagination.currentPage" :total-rows="pagination.totalRows" :per-page="pagination.perPage" />
        </div>
      </b-card>
    </div>

    <b-modal title="Firma Bilgileri" ref="companyModal" size="xl">
      <table class="table table-bordered">
        <tr>
          <th style="width:50%"><b>{{ $t("Başlık") }}</b></th>
          <th style="width:50%"><b>{{ $t("Değer") }}</b></th>
        </tr>
        <tr>
          <td><b>{{ $t("Firma Adı") }}</b></td>
          <td>{{ company.title }}</td>
        </tr>
        <tr>
          <td><b>{{ $t("Ad Soyad") }}</b></td>
          <td>{{ company.full_name }}</td>
        </tr>
        <tr>
          <td><b>{{ $t("Telefon") }}</b></td>
          <td>{{ company.phone }} - {{ company.gsm }}</td>
        </tr>
        <tr>
          <td><b>{{ $t("E - mail") }}</b></td>
          <td>{{ company.email }}</td>
        </tr>
        <tr>
          <td><b>{{ $t("Adresi") }}</b></td>
          <td>{{ company.address }} - {{ company.county }} / {{ company.city }}</td>
        </tr>
      </table>
    </b-modal>

  </div>
</template>

<script>
  import { mapActions } from 'vuex'
  export default {
    data () {
      return {
        company: {},
        status: 'Bekliyor',
        statusOptions: [
          { value: 'Bekliyor', text: 'Bekliyor' },
          { value: 'Hazırlanıyor', text: 'Hazırlanıyor' },
          { value: 'Tamamlandı', text: 'Tamamlandı' },
        ],
        pagination: {
          currentPage: 1,
          totalRows: 1,
          perPage: 15,
        },
        fields: [
          { key: 'product.name', label: 'Ürün Adı' },
          { key: 'product.barcode', label: 'Ürün Barkodu' },
          { key: 'company', label: 'Firma Adı' },
          { key: 'piece', label: 'Adet' },
          { key: 'price', label: 'Toplam Fiyat' },
          { key: 'note', label: 'Sipariş Notu' },
          { key: 'status', label: 'Sipariş Durumu' },
          { key: 'actions', label: '', tdClass: 'text-right' },
        ],
      }
    },
    methods: {
      ...mapActions([
        'getSuperProductOrders',
        'changeSuperProductOrderStatus'
      ]),
      changeItemStatus(order) {
        setTimeout(() => {
          this.changeSuperProductOrderStatus({
            order_id: order.id,
            status: order.status,
          }).then(response => {
            this.success(response.data.message);
          }).error(error => {
            this.error(error.response.data.message);
          })
        }, 200);
      },
      refreshTable () {
        this.$refs.table.refresh()
      },
      getItems () {
        const parameters = this.parameters()
        return this.getSuperProductOrders(parameters)
          .then(data => data.data).then(response => {
            this.pagination.totalRows = response.total
            return response.data;
          })
      },
      parameters(){
        const params = {}
        params.page = JSON.parse(JSON.stringify(this.pagination.currentPage))
        params.status = this.status;
        return params;
      },
    },
  }
</script>
